import TransferProfilePage from "./TransferProfilePage";

export default TransferProfilePage;
